import { render, staticRenderFns } from "./downloadModal.vue?vue&type=template&id=1136273f&scoped=true&"
import script from "./downloadModal.vue?vue&type=script&lang=js&"
export * from "./downloadModal.vue?vue&type=script&lang=js&"
import style0 from "./downloadModal.vue?vue&type=style&index=0&id=1136273f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136273f",
  null
  
)

export default component.exports